import { detect } from 'detect-browser'
import flexibility from 'flexibility'

export default function widgetPageChange (Site, $) {
  const reloads = ['/order/checkout']

  const ReloadsRegex = new RegExp(reloads.join('|'))

  Site.widget('url-reloader', {
    _create () {
      // Add the browser name to <body/>
      const browser = detect()
      $('html').addClass(browser.name)

      // Fake some flex
      if (browser.name === 'ie') {
        flexibility(document.body)
        flexibility(this.element[0])
      }
    },
    xhrPageWillLoad (path, jsPath, ...args) {
      let p = (path && path[1]) || jsPath

      if (ReloadsRegex.test(p.trim('/'))) {
        if (window.TRANSITION_IGNORE) {
          window.TRANSITION_IGNORE = false
          return
        }
        
        window.location = window.location.origin + p
        return false
      }
    }
  })
}
